import { casesActions } from "configs";
import { generateId, useCurrentCase, useDispatch, useParams } from "duck";
import {
  FluidTemperature,
  useCreateFluidAndTemperatureMutation
} from "requests";
import { getVolumeInfused } from "../../../../../../../../../duck";
import { FormValues } from "./types";

export const useCreateFluidAndTemperature = (patientId: number) => {
  const dispatch = useDispatch();
  const { id: caseId } = useParams();
  const [create] = useCreateFluidAndTemperatureMutation();
  const { shouldSync, fluidTemperatures } = useCurrentCase(medicalCase => ({
    shouldSync: medicalCase.shouldSync,
    fluidTemperatures: medicalCase.data.client?.patient?.fluidTemperatures
  }));

  return (values: FormValues) => {
    const variables = {
      fluidRate: values.fluidRate,
      temperature: values.temperature,
      timeMonitoring: values.timeMonitoring?.toISOString(),
      volumeToBeInfused: values.volumeToBeInfused,
      volumeInfused: getVolumeInfused(
        fluidTemperatures as FluidTemperature[],
        values.volumeToBeInfused
      )
    };

    if (shouldSync) {
      return create({
        variables: {
          input: {
            patient: patientId,
            ...variables
          }
        }
      }).then(response => {
        const newFluidAndTemperature =
          response.data?.createFluidTemperature?.fluidTemperature;
        if (newFluidAndTemperature) {
          dispatch(
            casesActions.addFluidAndTemperature({
              _id: caseId,
              data: newFluidAndTemperature
            })
          );
        }
      });
    }

    dispatch(
      casesActions.addFluidAndTemperature({
        _id: caseId,
        data: {
          fakeId: generateId(),
          ...variables
        }
      })
    );

    return Promise.resolve();
  };
};
